var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-date-picker",
    _vm._b(
      {
        staticClass: "my-select",
        style: _vm._style,
        attrs: {
          clearable: false,
          inline: "",
          type: _vm.type,
          "value-format": _vm.format,
          "range-separator": "-",
          "start-placeholder": _vm.$t("components.global.startDate"),
          "end-placeholder": _vm.$t("components.global.endDate"),
          disabled: _vm.disabled,
        },
        on: { change: _vm.change },
        model: {
          value: _vm._value,
          callback: function ($$v) {
            _vm._value = $$v
          },
          expression: "_value",
        },
      },
      "el-date-picker",
      _vm.$attrs,
      false
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }